module.exports = __webpack_public_path__ + "img/1.6b335c6c.jpg";